import React from "react";
import { Box } from "@mui/material";

export type Tone = "success" | "warning" | "error" | "info" | "primary" | "neutral";

const TONES: Record<Tone, { bg: string; fg: string }> = {
  success: { bg: "#DCFCE7", fg: "#15803D" },
  warning: { bg: "#FEF3C7", fg: "#B45309" },
  error: { bg: "#FEE2E2", fg: "#B91C1C" },
  info: { bg: "#E0F2FE", fg: "#0369A1" },
  primary: { bg: "#EEF2FF", fg: "#4338CA" },
  neutral: { bg: "#F1F5F9", fg: "#475569" },
};

interface Props {
  label: string;
  tone?: Tone;
  dot?: boolean;
}

/** Soft, modern status pill with an optional leading dot. */
const StatusPill: React.FC<Props> = ({ label, tone = "neutral", dot = true }) => {
  const { bg, fg } = TONES[tone];
  return (
    <Box
      component="span"
      sx={{
        display: "inline-flex",
        alignItems: "center",
        gap: 0.75,
        bgcolor: bg,
        color: fg,
        fontSize: "11.5px",
        fontWeight: 700,
        letterSpacing: "0.02em",
        px: 1.25,
        py: "4px",
        borderRadius: "100px",
        whiteSpace: "nowrap",
      }}
    >
      {dot && <Box component="span" sx={{ width: 6, height: 6, borderRadius: "50%", bgcolor: fg }} />}
      {label}
    </Box>
  );
};

export default StatusPill;
